/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import {
  Grid,
  Row,
  Col,
  Panel,
  Table,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import Toolbar from 'loracoms/Toolbar';
import gatewayActions from 'loraactions/gateway';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';
import { confSelector } from './selectors';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  getGatewayConf: React.PropTypes.func.isRequired,
  gatewayId: React.PropTypes.string.isRequired,
  gatewayConf: React.PropTypes.object,
};

const defaultProps = {
  gatewayConf: {},
};

class ConfView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gatewayConf: props.gatewayConf,
    };
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.detailview.band');
  }

  componentWillMount() {
    const { getGatewayConf, gatewayId } = this.props;
    getGatewayConf(gatewayId);
  }

  componentWillReceiveProps(nextProps) {
    const { gatewayConf } = nextProps;
    if (gatewayConf !== this.props.gatewayConf) {
      this.setState({ gatewayConf });
    }
  }

  computeFreq(obj) {
    const radioArr = [];
    Object.keys(obj).forEach((item) => {
      const config = obj[item];
      Object.keys(config).forEach((c) => {
        if (c.indexOf('radio') !== -1) {
          const itemIndex = c.split('_')[1];
          radioArr[itemIndex] = config[c].freq;
        }
      });
    });
    Object.keys(obj).forEach((item) => {
      const config = obj[item];
      Object.keys(config).forEach((c) => {
        if (c.indexOf('chan_multiSF') !== -1) {
          config[c].freq = config[c].if + radioArr[config[c].radio];
        }
      });
    });
    return obj;
  }

  subPropertyHaveObj(obj) {
    let check = false;
    Object.keys(obj).forEach((item) => {
      if (_.isPlainObject(obj[item])) {
        check = true;
      }
    });
    return check;
  }

  rederTrs(arr) {
    const value = (v) => {
      if (v === true) {
        return 'true';
      } else if (v === false) {
        return 'false';
      }
      return v;
    };
    const result = arr.map(item => (
      <li key={item.label}>
        <span className={styles['prop-name']}>
          {item.label}
        </span>
        <span className={styles['prop-value']}>
          <span>
            {value(item.value)}
          </span>
        </span>
      </li>
    ));
    return (
      <ul styleName="props-list">
        {result}
      </ul>
    );
  }

  splitObj(obj, pro) {
    const propertyLeft = {};
    const propertyRight = {};
    Object.keys(obj).forEach((item) => {
      if (this.subPropertyHaveObj(obj[item])) {
        const config = obj[item];
        propertyLeft[item] = {};
        propertyRight[item] = {};
        Object.keys(config).forEach((c) => {
          if (c === 'lbt_cfg') {
            return;
          }
          if (c.indexOf(pro) === -1) {
            propertyLeft[item][c] = config[c];
          } else {
            propertyRight[item][c] = config[c];
          }
        });
      }
    });
    return {
      leftObj: this.computeFreq(propertyLeft),
      rightObj: propertyRight,
    };
  }

  renderConfig(detail) {
    const data = [];
    const value = (v) => {
      if (v === true) {
        return 'true';
      } else if (v === false) {
        return 'false';
      }
      return v;
    };
    Object.keys(detail).forEach((item) => {
      if (this.subPropertyHaveObj(detail[item])) {
        if (typeof (detail[item]) === 'object') {
          const config = detail[item];
          Object.keys(config).forEach((c) => {
            if (typeof (config[c]) === 'object') {
              const configMin = config[c];
              const dataMin = [];
              Object.keys(configMin).forEach((m) => {
                dataMin.push({
                  label: m,
                  value: configMin[m],
                });
              });
              data.push({
                label: c,
                value: dataMin,
              });
            } else {
              data.push({
                label: c,
                value: config[c],
              });
            }
          });
        }
      }
    });
    const dataList = data;
    const trs = dataList.map((item, index) => (
      <tr key={`${item.label}-${index}`}>
        <td>
          {item.label}
        </td>
        <td>
          {
            _.isArray(item.value) ?
              this.rederTrs(item.value) :
              value(item.value)
          }
        </td>
      </tr>
    ));
    return (
      <Table
        className="aisz-table-light"
        striped
        hover
        bordered
        responsive
      >
        <tbody>
          {trs}
        </tbody>
      </Table>
    );
  }

  renderToolbar() {
    const breadcrumb = [{
      content: this.intlMsg.msg('breadcrumbs.gateways', 'gatewaydetail'),
      onClick: () => this.props.pushState('/gateway'),
    }, {
      content: this.intlMsg.msg('nav'),
      active: true,
    }];

    return <Toolbar breadcrumb={breadcrumb} />;
  }

  render() {
    const { gatewayConf } = this.state;
    let title = '';
    _.map(gatewayConf, (key, value) => {
      if (this.subPropertyHaveObj(value)) {
        title = key;
      }
    });

    let content = (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className={styles['props-panel']}>
              <Panel bsStyle="aisz-white" header={title}>
                <Row>
                  <Col md={6}>
                    {this.renderConfig(this.splitObj(gatewayConf, 'tx').leftObj)}
                  </Col>
                  <Col md={6}>
                    {this.renderConfig(this.splitObj(gatewayConf, 'tx').rightObj)}
                  </Col>
                </Row>
              </Panel>
            </div>
          </Col>
        </Row>
      </Grid>
    );

    if (_.isEmpty(gatewayConf)) {
      content = (
        <Grid fluid>
          <Row>
            <Col md={12}>
              {this.renderToolbar()}
            </Col>
          </Row>
          <Row>
            <Col mdOffset={4} md={4}>
              <div className={styles.unkownTips}>
                <span className="glyphicons glyphicons-exclamation-sign" />
                <h1>{this.intlMsg.msg('unkowntips')}</h1>
                <ul className="list-unstyled">
                  <li>
                    <span className="halflings halflings-hand-right" />
                    {' '}
                    {this.intlMsg.msg('unkowntips.reason1')}
                  </li>
                  <li>
                    <span className="halflings halflings-hand-right" />
                    {' '}
                    {this.intlMsg.msg('unkowntips.reason2')}
                  </li>
                  <li>
                    <span className="halflings halflings-hand-right" />
                    {' '}
                    {this.intlMsg.msg('unkowntips.reason3')}
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Grid>
      );
    }
    return (
      <div>
        {content}
      </div>
    );
  }
}

ConfView.propTypes = propTypes;
ConfView.defaultProps = defaultProps;

const mapStateToProps = (state, ownProps) => ({
  gatewayConf: confSelector(state),
  gatewayId: ownProps.params.id,
});

const mapDispatchToProps = {
  getGatewayConf: gatewayActions.gatewayConf,
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CSSModules(ConfView, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/ConfView/index.jsx